// Business Development (BD) tracker API client.
// Reuses the same token as Partner-Pharmacies (both routers share pp_sessions).
import axios from "axios";
import { getToken } from "./authSession";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const bdApi = axios.create({
  baseURL: `${BACKEND}/api/bd`,
});

bdApi.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers["X-Auth-Token"] = t;
  return config;
});

// Attempts
export const listAttempts = (pharmacyId) =>
  bdApi.get("/attempts", { params: { pharmacy_id: pharmacyId } }).then((r) => r.data.items || []);
export const createAttempt = (payload) =>
  bdApi.post("/attempts", payload).then((r) => r.data);
export const updateAttempt = (id, patch) =>
  bdApi.patch(`/attempts/${id}`, patch).then((r) => r.data);
export const deleteAttempt = (id) =>
  bdApi.delete(`/attempts/${id}`).then((r) => r.data);
export const attemptStats = (pharmacyId) => {
  const params = pharmacyId ? { pharmacy_id: pharmacyId } : {};
  return bdApi.get("/attempt-stats", { params }).then((r) => r.data.pharmacies || {});
};

// Titles + Outcomes share the same shape.
const listCol = (path) => () => bdApi.get(path).then((r) => r.data.items || []);
const createCol = (path) => (name) => bdApi.post(path, { name }).then((r) => r.data);
const renameCol = (path) => (id, name) => bdApi.patch(`${path}/${id}`, { name }).then((r) => r.data);
const deleteCol = (path) => (id) => bdApi.delete(`${path}/${id}`).then((r) => r.data);

export const listTitles = listCol("/titles");
export const createTitle = createCol("/titles");
export const renameTitle = renameCol("/titles");
export const deleteTitle = deleteCol("/titles");

export const listOutcomes = listCol("/outcomes");
export const createOutcome = createCol("/outcomes");
export const renameOutcome = renameCol("/outcomes");
export const deleteOutcome = deleteCol("/outcomes");
